export interface ReportTableColumn {
  label: string;
  value?: any;
  colSpan?: number;
  cssClass?: string;
  textRight?: boolean;
  textCenter?: boolean;
  widthSmall?: boolean;
}
